import React from "react";
import {Route, Switch} from "react-router-dom";

import asyncComponent from "util/asyncComponent";

const App = ({match}) => (
  <div className="gx-main-content-wrapper">
    <Switch>
      <Route exact path={`${match.url}`} component={asyncComponent(() => import('./Main'))}/>
      <Route exact path={`${match.url}/affiliatesList`} component={asyncComponent(() => import('../mayorDashboard/ClientsList'))}/>
      <Route exact path={`${match.url}/affiliatesRequest`} component={asyncComponent(() => import('../mayorDashboard/ClientsRequests'))}/>
      <Route exact path={`${match.url}/affiliatesInvitations`} component={asyncComponent(() => import('../mayorDashboard/ClientsInvitations'))}/>
      <Route exact path={`${match.url}/ordersCancelled`} component={asyncComponent(() => import('../mayorDashboard/OrdersCancelled'))}/>
      <Route exact path={`${match.url}/ordersComplete`} component={asyncComponent(() => import('../mayorDashboard/OrdersCompleted'))}/>
      <Route exact path={`${match.url}/ordersWaiting`} component={asyncComponent(() => import('../mayorDashboard/OrdersWaiting'))}/>
      <Route exact path={`${match.url}/ordersAdd`} component={asyncComponent(() => import('./OrdersAdd'))}/>
      <Route exact path={`${match.url}/ordersList`} component={asyncComponent(() => import('../mayorDashboard/OrdersList'))}/>
      <Route exact path={`${match.url}/invoices`} component={asyncComponent(() => import('./InvoicesList'))}/>
      <Route exact path={`${match.url}/createOrder`} component={asyncComponent(() => import('./CreateOrder'))}/>
      <Route exact path={`${match.url}/editProfile`} component={asyncComponent(() => import('./EditProfile'))}/>
    </Switch>
  </div>
);

export default App;
